//src/utils/imageCompress.js
/**
 * Compress an image (keep original width/height by default).
 * Converts to PNG to reduce size while preserving format.
 *
 * @param {File|Blob} fileOrBlob
 * @param {{quality?: number, maxSide?: number|null}} options
 * - quality: 0..1
 * - maxSide: if set, will resize down if the image is larger than this (prevents huge uploads)
 */
export async function compressImage(fileOrBlob, options = {}) {
  const quality = typeof options.quality === "number" ? options.quality : 0.7;
  const maxSide = options.maxSide ?? null; // set e.g. 2000 to prevent huge images

  const imgUrl = URL.createObjectURL(fileOrBlob);
  const img = new Image();
  img.crossOrigin = "anonymous"; // തിരുത്തിയത്: അധികം വന്ന ബാക്ക്‌സ്ലാഷ് ഒഴിവാക്കി
  img.src = imgUrl;

  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
  });

  let { naturalWidth: w, naturalHeight: h } = img;

  // Optional downscale (recommended to avoid 8K photos)
  if (maxSide && Math.max(w, h) > maxSide) {
    const scale = maxSide / Math.max(w, h);
    w = Math.round(w * scale);
    h = Math.round(h * scale);
  }

  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, w, h);

  URL.revokeObjectURL(imgUrl);

  return new Promise((resolve) => {
    // Force PNG format instead of 'image/jpeg' to meet your requirement
    canvas.toBlob((blob) => {
      resolve(blob);
    }, "image/png", quality);
  });
}